<template>
    <div class="animated fadeIn">
        <b-row class="my-3">
            <b-col>
                <h4 class="text-center text-primary">
                    <i class="fa fa-bank text-primary mr-2"></i>
                    Gestiones bancarias
                </h4>
            </b-col>
        </b-row>

        <b-row class="pb-2">
            <b-card class="w-100">
                <b-row slot="header" class="m-0 p-0 justify-content-between align-items-center">
                    {{ banksTitle }}
                    <export-actions :rows="getBanksFilteredData()"></export-actions>
                </b-row>
                <v-client-table
                    ref="banksTable"
                    class="dataTable"
                    md="12"
                    lg="12"
                    sm="12"
                    :columns="columns"
                    :data="items"
                    :options="options"
                    :theme="theme">

                    <template slot="uuid" slot-scope="props">
                        <i
                            size="sm"
                            @click.stop="selectBank(props.row.uuid)"
                            v-b-modal.newItem
                            class="fa fa-pencil text-primary">
                        </i>
                    </template>

                </v-client-table>
            </b-card>
        </b-row>

        <b-row class="py-2">
            <b-card class="w-100">
                <b-row slot="header" class="m-0 p-0 justify-content-between align-items-center">
                    {{ bankAccountsTitle }}
                    <export-actions :rows="getBankAccountsFilteredData()"></export-actions>
                </b-row>
                <v-client-table
                    ref="bankAccountsTable"
                    class="dataTable"
                    md="12"
                    lg="12"
                    sm="12"
                    :columns="columnsB"
                    :data="itemsB"
                    :options="optionsB"
                    :theme="theme" @filter="onFilter">

                    <template slot="uuid" slot-scope="props">
                        <i
                            size="sm"
                            @click.stop="selectBankAccount(props.row.uuid)"
                            v-b-modal.newItemB
                            class="fa fa-pencil text-primary">
                        </i>
                    </template>

                    <template slot="account" slot-scope="props">
                        &nbsp; {{ props.row.entity }} &nbsp; {{ props.row.office }} &nbsp; {{ props.row.control_digit }}
                        &nbsp; {{ props.row.account_number }}
                    </template>

                </v-client-table>
            </b-card>
        </b-row>

        <b-modal
            id="newItem"
            ref="newItem"
            title="Definir Banco"
            ok-title="Guardar"
            cancel-title="Cancelar"
            @ok="storeBank"
            hide-footer
            v-model="showA">
            <b-form @submit.prevent="storeBank">
                <b-form-group class="w-100">
                    <label for="code"><strong>Código Europeo *</strong></label>
                    <b-input-group>
                        <b-form-input
                            type="text"
                            id="code"
                            placeholder="Introduzca código europeo"
                            v-model="item.code"
                            :required="true">
                        </b-form-input>
                    </b-input-group>
                </b-form-group>
                <b-form-group class="w-100">
                    <label for="name"><strong>Nombre *</strong></label>
                    <b-input-group>
                        <b-form-input
                            type="text"
                            id="name"
                            placeholder="Introduzca nombre"
                            v-model="item.name"
                            :required="true">
                        </b-form-input>
                    </b-input-group>
                </b-form-group>
                <label for="address"><strong>Dirección *</strong></label>
                <b-form-textarea
                    id="address"
                    v-model="item.address"
                    placeholder="Describa el departamento"
                    :rows="3"
                    :max-rows="6"
                    :required="true">
                </b-form-textarea>

                <b-row class="border-top pt-3 px-3 mt-4">
                    <button
                        v-if="item.uuid && mixinCheckPermission('BANK_DELETE')"
                        type="button"
                        @click="removeBank()"
                        class="btn btn-brand btn-danger col-auto mr-auto btn-lg"
                        sm="12">
                        Eliminar
                    </button>
                    <button
                        v-else
                        type="button"
                        @click="hideModal()"
                        class="btn btn-brand btn-danger col-auto mr-auto btn-lg"
                        sm="12">Cerrar
                    </button>
                    <button
                        type="submit"
                        class="btn btn-brand btn-primary col-auto btn-lg" sm="12"
                        v-if="mixinCheckPermissions(['BANK_NEW', 'BANK_EDIT'])">
                        Guardar
                    </button>
                </b-row>
            </b-form>
        </b-modal>

        <b-modal
            id="newItemB"
            ref="newItemB"
            title="Definir Remesa"
            ok-title="Guardar"
            cancel-title="Cancelar"
            @ok="storeBankAccount"
            hide-footer
            v-model="showB">
            <b-form @submit.prevent="storeBankAccount">
                <b-row class="px-3">
                    <b-form-group class="w-100">
                        <label for="code"><strong>Código Banco *</strong></label>
                        <multiselect
                            name="entity"
                            v-model="itemB.entity"
                            :allow-empty="false"
                            :options="items.map(type => type.code)"
                            :multiple="false"
                            :custom-label="opt => items.find(x => x.code == opt).name"
                            selectLabel="+"
                            deselectLabel="-"
                            placeholder="Seleccione opción">
                        </multiselect>
                    </b-form-group>
                </b-row>
                <b-row>
                    <b-col md="3">
                        <b-form-group>
                            <label for="entity"><strong>Entidad *</strong></label>
                            <b-input-group>
                                <b-form-input
                                    type="number"
                                    minlength="4"
                                    max="9999"
                                    id="entity"
                                    placeholder="0000"
                                    v-model="itemB.entity"
                                    required>
                                    <i class="fa fa-user"></i>
                                </b-form-input>
                            </b-input-group>
                        </b-form-group>
                    </b-col>
                    <b-col md="3">
                        <b-form-group>
                            <label for="office"><strong>Oficina *</strong></label>
                            <b-input-group>
                                <b-form-input
                                    type="number"
                                    max="9999"
                                    id="office"
                                    placeholder="0000"
                                    v-model="itemB.office"
                                    :required="true">
                                    <i class="fa fa-user"></i>
                                </b-form-input>
                            </b-input-group>
                        </b-form-group>
                    </b-col>
                    <b-col md="2">
                        <b-form-group>
                            <label for="controlDigit"><strong>DC *</strong></label>
                            <b-input-group>
                                <b-form-input
                                    type="number"
                                    id="controlDigit"
                                    max="99"
                                    placeholder="00"
                                    v-model="itemB.controlDigit"
                                    :required="true">
                                    <i class="fa fa-user"></i>
                                </b-form-input>
                            </b-input-group>
                        </b-form-group>
                    </b-col>
                    <b-col md="4">
                        <b-form-group>
                            <label for="accountNumber"><strong>Cuenta *</strong></label>
                            <b-input-group>
                                <b-form-input
                                    type="number"
                                    id="accountNumber"
                                    max="9999999999"
                                    placeholder="0000000000"
                                    v-model="itemB.accountNumber"
                                    :required="true">
                                    <i class="fa fa-user"></i>
                                </b-form-input>
                            </b-input-group>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row class="px-3">
                    <template v-if="!validateIBAN()">
                        <pre class="text-warning">Complete correctamente la cuenta</pre>
                    </template>
                </b-row>

                <b-row class="border-top pt-3 px-2 mt-4">
                    <button
                        v-if="itemB.uuid && mixinCheckPermission('BANK_DELETE')"
                        type="button"
                        @click="removeBankAccount()"
                        class="btn btn-brand btn-danger col-auto mr-auto btn-lg"
                        sm="12">
                        Eliminar
                    </button>
                    <button
                        v-else
                        type="button"
                        @click="hideModal()"
                        class="btn btn-brand btn-danger col-auto mr-auto btn-lg"
                        sm="12">Cerrar
                    </button>
                    <button
                        type="submit"
                        class="btn btn-brand btn-primary col-auto btn-lg"
                        sm="12"
                        :disabled="!validateIBAN()"
                        v-if="mixinCheckPermissions(['BANK_ADD', 'BANK_EDIT'])">
                        Guardar
                    </button>
                </b-row>
            </b-form>
        </b-modal>
    </div>
</template>

<script>

    import VueNotifications from 'vue-notifications';
    import Multiselect from 'vue-multiselect';
    import Vue from 'vue';
    import {ClientTable, Event} from 'vue-tables-2';
    import form from '@/helpers/form';
    import ExportActions from '@/components/ExportActions';

    Vue.use(ClientTable);

    export default {
        name: 'listBanks',
        components: {
            ClientTable,
            Event,
            Multiselect,
            ExportActions
        },
        mounted() {
            this.$eventHub.$on('newBank', obj => {
                this.flushBankData();
                this.$refs.newItem.show();
            });
            this.$eventHub.$on('newBankAccount', obj => {
                this.flushBankAccountData();
                this.$refs.newItemB.show();
            });
            this.$eventHub.$emit('captureMenu', this.topmenu);
            this.options.texts = form.tableLabels();
            this.optionsB.texts = form.tableLabels();
            this.getBanks();
            this.getBanksAccounts();
        },
        beforeDestroy() {
            this.$eventHub.$off('newBank');
            this.$eventHub.$off('newBankAccount');
        },
        data: function () {
            return {
                topmenu: [
                    {name: 'Inicio', path: '/admin/dashboard', brand: 'fa fa-home'},
                    {name: 'Nuevo Banco', emit: 'newBank', brand: 'fa fa-bank', permissions: ['BANK_NEW']},
                    {
                        name: 'Nueva Cuenta para Remesar',
                        emit: 'newBankAccount',
                        brand: 'fa fa-credit-card-alt',
                        permissions: ['BANK_NEW']
                    },
                ],

                columns: ['uuid', 'code', 'name', 'address'],
                options: {
                    headings: {
                        uuid: {
                            text: '',
                            id: 'fit'
                        },
                        code: 'Código Europeo',
                        name: 'Nombre',
                        address: 'Dirección',
                    },
                    columnsClasses: {uuid: "fit"},
                    sortable: ['code', 'name', 'address'],
                    filterable: ['code', 'name', 'address'],
                    sortIcon: {base: 'fa', up: 'fa-sort-asc', down: 'fa-sort-desc', is: 'fa-sort'},
                    perPageValues: [10, 25, 50, 100, 500, 1000],
                    texts: null,
                    pagination: {
                        chunk: 5,
                        edge: true,
                        nav: 'scroll'
                    }
                },
                columnsB: ['uuid', 'code', 'ccc'],
                optionsB: {
                    headings: {
                        uuid: {
                            text: '',
                            id: 'fit'
                        },
                        code: 'Código Europeo',
                        name: 'Nombre',
                        ccc: 'Cod. Entidad Sucursal DC Cuenta'
                    },
                    columnsClasses: {uuid: "fit"},
                    sortable: ['code', 'ccc'],
                    filterable: ['code', 'ccc'],
                    sortIcon: {base: 'fa', up: 'fa-sort-asc', down: 'fa-sort-desc', is: 'fa-sort'},
                    perPageValues: [10, 25, 50, 100, 500, 1000],
                    texts: null,
                    pagination: {
                        chunk: 5,
                        edge: true,
                        nav: 'scroll'
                    }
                },
                useVuex: false,
                theme: 'bootstrap4',
                template: 'default',
                items: [],
                item: {
                    uuid: 0,
                    code: "",
                    name: "",
                    address: "",
                },
                items_url: 'banks',
                banksTitle: 'Listado de bancos',
                itemsB: [],
                itemB: {
                    uuid: 0,
                    bankId: 0,
                    code: '',
                    entity: '',
                    office: '',
                    controlDigit: '',
                    accountNumber: ''
                },
                items_urlB: 'banks/accounts',
                bankAccountsTitle: 'Cuentas bancarias para remesas',
                showA: false,
                showB: false,
                checkCc: true,
            }
        },
        methods: {
            getBanks() {
                this.$_loadingMixin_showLoading();
                let self = this;
                let path = this.items_url;
                axios.get(path)
                    .then(function (response) {
                        if (response.status == "200") {
                            self.items = response.data;
                          let searchValue = this.$store.getters.getTextFilter;
                          if (searchValue === null || searchValue === '') {
                            //console.log(this.headquarters)
                          }  else {
                            document.querySelector('.VueTables__search__input').value  = this.$store.getters.getTextFilter;
                            let filteredLists = []
                            this.headquarters.map(function (e) {
                              if (e.code === searchValue || e.name.includes(searchValue) || e.address.includes(searchValue)) {
                                filteredLists.push(e)
                              }
                            });
                            self.items = filteredLists;
                          }
                            self.$_loadingMixin_hideLoading();
                        }
                    })
                    .catch(function (error) {
                        self.showErrorMsg();
                        self.$_loadingMixin_hideLoading();
                    });
            },
            getBanksAccounts() {
                this.$_loadingMixin_showLoading();
                let self = this;
                let path = this.items_urlB;

                axios.get(path)
                    .then(function (response) {
                        if (response.status == "200") {
                            self.itemsB = response.data;
                        }
                        self.$_loadingMixin_hideLoading();

                    })
                    .catch(function (error) {
                        self.showErrorMsg();
                        self.$_loadingMixin_hideLoading();
                    });
            },
            storeBank() {
                this.$_loadingMixin_showLoading();
                let self = this;
                let path = this.items_url;
                let type = "post";
                let error = 201;
                let option = 1;

                if (this.item.uuid) {
                    path = this.items_url + "/" + this.item.uuid;
                    type = "put";
                    error = 200;
                    option = 2;
                }
                axios({method: type, url: path, data: this.item})
                    .then(function (response) {
                        if (response.status == error) {
                            self.showA = false;
                            self.showSuccessMsg();
                            self.flushBankData();
                            self.getBanks();
                        }
                        self.$_loadingMixin_hideLoading();
                    })
                    .catch(function (error) {
                        if (error.response.status == 400) {
                            self.showFormatMsg();
                        } else {
                            self.showErrorMsg();
                        }
                        self.$_loadingMixin_hideLoading();
                    });

            },
            storeBankAccount() {
                this.$_loadingMixin_showLoading();
                let self = this;
                let path = this.items_url + "/" + this.itemB.bankId + "/accounts";
                let type = "post";
                let error = 201;
                let option = 1;
                if (this.itemB.uuid) {
                    path = this.items_url + "/" + this.itemB.bankId + "/accounts/" + this.itemB.uuid;
                    type = "put";
                    error = 200;
                    option = 2;
                }
                axios({method: type, url: path, data: this.itemB})
                    .then(function (response) {
                        if (response.status == error) {
                            self.showB = false;
                            self.showSuccessMsg();
                            self.flushBankAccountData();
                            self.getBanksAccounts();
                        }
                        self.$_loadingMixin_hideLoading();
                    })
                    .catch(function (error) {
                        if (error.response.status == 400) {
                            self.showFormatMsg();
                        } else {
                            self.showErrorMsg();
                        }
                        self.$_loadingMixin_hideLoading();
                    });
            },
            removeBank() {
                this.$_loadingMixin_showLoading();
                let self = this;
                let url = this.items_url + "/" + this.item.uuid;
                swal({
                    title: '¿Estás seguro?', text: "Esta operación no se podrá revertir", type: 'warning',
                    showCancelButton: true, cancelButtonText: 'Cancelar', confirmButtonText: 'Sí, elimínalo!'
                }).then((result) => {
                    if (result.value) {
                        axios.delete(url)
                            .then(function (response) {
                                if (response.status == "200") {
                                    self.showSuccessMsg({
                                        title: 'Operación Completada',
                                        message: 'Registro eliminado con éxito'
                                    });
                                    self.flushBankData();
                                    self.getBanks();
                                }
                                self.$_loadingMixin_hideLoading();
                            })
                            .catch(function (error) {
                                if (error.code == 400) {
                                }
                                self.showErrorMsg();
                                self.$_loadingMixin_hideLoading();
                            });
                    }
                });
                this.showA = false;
            },
            removeBankAccount() {

                this.$_loadingMixin_showLoading();

                let self = this;
                let url = this.items_url + "/" + this.itemB.bankId + "/accounts/" + this.itemB.uuid;

                swal({
                    title: '¿Estás seguro?', text: "Esta operación no se podrá revertir", type: 'warning',
                    showCancelButton: true, cancelButtonText: 'Cancelar', confirmButtonText: 'Sí, elimínalo!'
                }).then((result) => {
                    if (result.value) {
                        axios.delete(url)
                            .then(function (response) {
                                if (response.status == "200") {
                                    self.showSuccessMsg({
                                        title: 'Operación Completada',
                                        message: 'Registro eliminado con éxito'
                                    });
                                    self.flushBankAccountData();
                                    self.getBanksAccounts();
                                }
                                self.$_loadingMixin_hideLoading();
                            })
                            .catch(function (error) {
                                if (error.code == 400) {
                                }
                                self.showErrorMsg();
                                self.$_loadingMixin_hideLoading();
                            });
                    }
                });
                this.showB = false;
            },
            selectBank(uuid) {
                let it = this.items.find(function (ite) {
                    return ite.uuid == uuid;
                });
                this.item.uuid = it.uuid;
                this.item.code = it.code;
                this.item.name = it.name;
                this.item.address = it.address;
            },
            selectBankAccount(uuid) {
                let it = this.itemsB.find(function (ite) {
                    return ite.uuid == uuid;
                });
                this.itemB.uuid = it.uuid;
                this.itemB.bankId = it.bank.uuid;
                this.itemB.code = it.code;
                this.itemB.entity = it.entity;
                this.itemB.office = it.office;
                this.itemB.controlDigit = it.controlDigit;
                this.itemB.accountNumber = it.accountNumber;
            },
            flushBankData() {
                this.item.uuid = 0;
                this.item.code = '';
                this.item.name = '';
                this.item.address = '';
            },
            flushBankAccountData() {
                this.itemB.uuid = 0;
                this.itemB.bankId = 0;
                this.itemB.code = '';
                this.itemB.entity = '';
                this.itemB.office = '';
                this.itemB.controlDigit = '';
                this.itemB.accountNumber = '';
            },
            validateIBAN() {
                var iban = form.generateIBAN(
                    this.itemB.entity
                    + this.itemB.office
                    + this.itemB.controlDigit
                    + this.itemB.accountNumber
                );

                if (iban) {
                    this.itemB.code = iban;
                }

                return form.checkIBAN(
                    this.itemB.code
                    + this.itemB.entity
                    + this.itemB.office
                    + this.itemB.controlDigit
                    + this.itemB.accountNumber
                );
            },
            hideModal() {
                this.$refs.newItem.hide();
                this.$refs.newItemB.hide();
            },
            getBanksFilteredData() {
                if (!!this.$refs.banksTable) {
                    return this.$refs.banksTable.allFilteredData.map(bank => ({
                        'Código Europeo': bank.code,
                        'Nombre': bank.name,
                        'Dirección': bank.address
                    }));
                } else {
                    return [];
                }
            },
            getBankAccountsFilteredData() {
                if (!!this.$refs.bankAccountsTable) {
                    return this.$refs.bankAccountsTable.allFilteredData.map(bankAccount => ({
                        'Código Europeo': bankAccount.code,
                        'Cod. Entidad Sucursal DC Cuenta': bankAccount.ccc
                    }));
                } else {
                    return [];
                }
            },
            onFilter () {
              let _self = this;
              if (document.querySelector('.VueTables__search__input').value === '') {
                _self.$store.commit('SET_USER_TEXT_FILTER', document.querySelector('.VueTables__search__input').value)
                _self.getBanks();
              } else {
                _self.$store.commit('SET_USER_TEXT_FILTER', document.querySelector('.VueTables__search__input').value)
              }
            }
        },
        notifications: {
            showSuccessMsg: {
                type: VueNotifications.types.success,
                title: 'Operación completada',
                message: 'Registrado con éxito'
            },
            showFormatMsg: {
                type: VueNotifications.types.error,
                title: 'Operación rechazada',
                message: 'Por favor revise los campos'
            },
            showErrorMsg: {
                type: VueNotifications.types.error,
                title: 'Operación denegada',
                message: 'Algo salió mal'
            }
        },
        watch: {
            'itemB.entity': function () {
                let self = this;
                if (!this.itemB.entity) {
                    return;
                }
                let bnk = this.items.find(bank => bank.code === self.itemB.entity);
                this.itemB.bankId = bnk.uuid;
            },
        },
    }
</script>

